export const description = '零方科技长期深耕便利店行业，熟悉零售业务，能准确、快速地理解和洞察客户需求，为零售行业专业定制解决方案，同时也培养了许多零售行业内的精英技术人才。 零方科技肩负“成为中国最具竞争力的数字化零售服务商，服务中国700万家门店”的使命，不断利用科技手段推进及引领行业变革，牵头探索互联网新业务模式'

export const keywords = '美宜佳，东莞美宜佳，便利店，零方信息科技有限公司，零方科技'
